import i18n from "../../../i18n";import { Trans } from "react-i18next";import { ui } from "../../../components/ui";

const fieldLabelClass = "block text-xs font-semibold per-file-hint mb-1.5";

function YesNoToggle({ label, value, onChange }) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className={fieldLabelClass}>{label}</span>
      <div className="inline-flex rounded-xl border border-(--color-text-border) p-0.5 w-fit bg-white">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`h-8 px-4 rounded-[10px] text-xs font-semibold transition ${
          value ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"}`
          }>
          <Trans i18nKey="common.yes" />
        
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`h-8 px-4 rounded-[10px] text-xs font-semibold transition ${
          !value ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"}`
          }>
          <Trans i18nKey="common.no" />
        
        </button>
      </div>
    </div>);

}

function OtHoursField({ label, field, formState, setFormState, fieldErrors, validateField, placeholder, disabled }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className={fieldLabelClass}>
        {label} {!disabled && <span className="text-error">*</span>}
      </span>
      <input
        type="number"
        step="0.5"
        min="0"
        disabled={disabled}
        placeholder={placeholder}
        className={`${ui.input} w-full disabled:bg-workspace/40 disabled:per-file-hint disabled:cursor-not-allowed ${
        !disabled && fieldErrors[field] ? "border-error focus:border-error" : ""}`
        }
        value={formState[field]}
        onChange={(e) => {
          const value = e.target.value;
          // Step 1: Update form state safely
          setFormState((p) => ({ ...p, [field]: value }));

          // Step 2: Extract a clean lookahead object snapshot to run field validation rules
          const nextState = { ...formState, [field]: value };
          validateField(field, value, nextState);
        }} />
      
      {!disabled && fieldErrors[field] &&
      <p className="text-[11px] text-error mt-1">{fieldErrors[field]}</p>
      }
    </label>);

}

export function OvertimeRuleFields({ formState, setFormState, fieldErrors, setFieldErrors, validateField }) {
  const otDisabled = !formState.overtimeEnabled;

  const handleOvertimeToggle = (enabled) => {
    setFormState((p) => ({ ...p, overtimeEnabled: enabled, compOffEnabled: enabled ? false : p.compOffEnabled }));
    if (!enabled) {
      // OT-hours fields are ignored/cleared and excluded from validation when OT is off.
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next.minimumOvertimeHours;
        delete next.halfDayOvertimeHours;
        delete next.fullDayOvertimeHours;
        return next;
      });
    }
  };

  const handleCompOffToggle = (enabled) => {
    setFormState((p) => ({ ...p, compOffEnabled: enabled, overtimeEnabled: enabled ? false : p.overtimeEnabled }));
    if (enabled) {
      // OT is being turned off as a side effect, so clear its errors too.
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next.minimumOvertimeHours;
        delete next.halfDayOvertimeHours;
        delete next.fullDayOvertimeHours;
        return next;
      });
    }
  };

  const otFieldProps = { formState, setFormState, fieldErrors, validateField, disabled: otDisabled };

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <YesNoToggle
          label="Overtime Enabled"
          value={formState.overtimeEnabled}
          onChange={handleOvertimeToggle} />
        
        <YesNoToggle
          label="Comp Off Enabled"
          value={formState.compOffEnabled}
          onChange={handleCompOffToggle} />
        
      </div>

      {otDisabled &&
      <p className="text-[12px] per-file-hint px-1">
          <Trans i18nKey="dateTime.otHoursFieldsAreDisabledSetOvertimeEnabled" />
        </p>
      }

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <OtHoursField
          label="Minimum Overtime Hours"
          field="minimumOvertimeHours"
          placeholder={i18n.t("examples.eG05")}
          {...otFieldProps} />
        
        <OtHoursField
          label="Half Day Overtime Hours"
          field="halfDayOvertimeHours"
          placeholder={i18n.t("examples.eG2")}
          {...otFieldProps} />
        
        <OtHoursField
          label="Full Day Overtime Hours"
          field="fullDayOvertimeHours"
          placeholder={i18n.t("examples.eG4")}
          {...otFieldProps} />
        
      </div>
    </div>);

}
